import { useParams } from '@tanstack/react-router';

import { CreateEnquiryFlow } from '../create-enquiry/CreateEnquiryFlow';

export const EnquiryDraftPage = () => {
    const { id } = useParams({ from: '/_app/orders_/draft/$id' });
    return <CreateEnquiryFlow orderId={id} />;
};
